<template>
  <div>
    <QSlider
      v-bind="$attrs"
      v-on="$listeners"
      :color="color"
      :min="min"
      :max="max"
    />
    <div v-if="labels" class="row label-container">
      <div class="end-label text-left">
        {{ labels[0] }}
      </div>
      <div
        v-for="label in labels.slice(1, labels.length - 1)"
        v-bind:key="label"
        class="middle-label text-center"
      >
        {{ label }}
      </div>
      <div class="end-label text-right overflow-left">
        {{ labels[labels.length - 1] }}
      </div>
    </div>
  </div>
</template>

<script>
import { QSlider } from 'quasar';
export default {
  name: 'SAISlider',
  props: {
    labels: {
      type: Array,
      default: () => []
    },
    color: {
      type: String,
      default: 'primary'
    },
    min: {
      type: Number,
      default: 0
    },
    max: {
      type: Number,
      default: 0
    }
  },
  components: {
    QSlider
  }
};
</script>

<style lang="sass" scoped>
.label-container
  display: flex
  align-content: stretch
.middle-label
  flex-grow: 2
  flex-basis: 0
.end-label
  flex-grow: 1
  flex-basis: 0
.overflow-left
  overflow: visible
</style>
